import Vue from 'vue';
import AntdUI from 'ant-design-vue';
import VueStorage from 'vue-ls';
import { VueServiceInstall } from '@/utils/request';
import PermissionHelper from '@/utils/helper/permission';
import bootstrap from '@/store/bootstrap';
import App from './App.vue';
import router from './router';
import store from './store';
import { WaterMark } from '@tencent/tks-utils/canvas';
import './global.less';

import Aegis from '@tencent/aegis-web-sdk';
import { APPID } from '@/config';
import TksAccount from '@/libs/MapAccount';

Vue.config.productionTip = false;

Vue.directive('waterMark', {
  inserted(el, binding) {
    WaterMark(el, binding.value);
  },
});
Vue.use(AntdUI);
Vue.use(VueStorage);
Vue.use(VueServiceInstall);
Vue.use(PermissionHelper);


// 初始化账号平台sdk

let ENV = 'test'; // 账号平台预发环境
if (window.location.origin === 'https://tianshu.map.qq.com' || window.location.origin === 'https://jf.map.qq.com') {
  ENV = 'prod'; // 账号平台正式环境
}
const path = window.location.pathname.replace(/index\.html/, '');
const ssoProxyPath = `${window.location.origin + path}mapssoproxy.html`;
TksAccount.init({
  platformId: APPID,
  ssoProxyPath,
  env: ENV,
});
const BLOCK_MSG = [
  'aegis.qq.com/collect/offlineAuto',
  'ResizeObserver loop limit exceeded',
  'pingjs.qq.com/tcss.ping.js',
  'dayu.oa.com/avatars/',
  'log.kslogs.ru',
  'cdnm3.cdnservice.space/start5.json',
  'event handler for "menuCollapsed"',
  'cdn-go.cn',
  'Script error',
  '401',
  'unknown',
  'getAttribute',
  "Cannot set properties of undefined (setting 'page')", // 小马BI内部报错
  'res status: 0', // status为0情况参考：https://cloud.tencent.com/document/product/1464/58608
];
const BLOCK_LEVEL = [
  '64', // 图片加载异常
  '1024', // retcode异常 参考：https://cloud.tencent.com/document/product/1464/58556#retcode.E5.BC.82.E5.B8.B8
];
// eslint-disable-next-line no-new
const aegies = new Aegis({
  // id: '3DEar4MGlR5GBvn26K', // 测试
  id: 'ZmpP9jNj4WeYBqax8V', // 正式
  uin: '',
  reportApiSpeed: true,
  reportAssetSpeed: true,
  spa: true,
  beforeRequest(data) {
    if (data.logType === 'log' && data.logs.msg.indexOf('cdn.map.qq.com') > -1) {
      return false;
    }
    if (data.logType === 'speed' && data.logs.url.indexOf('cdn.map.qq.com') > -1) {
      return false;
    }
  },
  beforeReport(log) {
    // 屏蔽掉指定报错
    // 屏蔽指定level的日志
    const { level, msg } = log;
    const lindex = BLOCK_LEVEL.findIndex((v) => level.indexOf(v) > -1);
    if (lindex > -1) {
      return false;
    }
    // 屏蔽指定msg的日志
    const mindex = BLOCK_MSG.findIndex((v) => msg.indexOf(v) > -1);
    if (mindex > -1) {
      return false;
    }
    return log;
  },
});

Vue.config.errorHandler = function (err, vm, info) {
  console.error(`Error : ${err.toString()}\nInfo: ${info}${err.toString()}`);
  aegies.error(`Error: ${err.toString()}\nInfo: ${info}`);
};
new Vue({
  router,
  store,
  created() {
    bootstrap();
  },
  // eslint-disable-next-line arrow-parens
  render: h => h(App),
}).$mount('#app');
